export enum BuildType {
  DEV = 'dev',
  STAGING = 'staging',
  DEMO = 'demo',
  PRODUCTION = 'production',
  TEST = 'test',
}
